import React from 'react';
import styled from 'styled-components';

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <MainSection>
          <TopSection>
            <Logo>
              <img 
                src="/images/logo-campus-new.svg"
                alt="TOBE DOCTOR CAMPUS" 
                onError={(e) => {
                  console.error('Logo failed to load');
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  const logoDiv = target.parentElement;
                  if (logoDiv) {
                    logoDiv.innerHTML = '<div style="color: #448181; font-weight: 600; font-size: 16px; white-space: nowrap;">TOBE DOCTOR CAMPUS</div>';
                  }
                }}
              />
            </Logo>
            <FooterLinks>
              <FooterLinkText>공지사항</FooterLinkText>
              <FooterLinkText>이용약관</FooterLinkText>
              <FooterLinkText>개인정보 처리방침</FooterLinkText>
            </FooterLinks>
          </TopSection>
          
          <FooterDescription>
            「대한민국의학한림원 × 투비닥터 의료 AI 캠퍼스」는 대한민국의학한림원과 정보통신산업진흥원의 지원을 받아 구축된 의료 AI 교육 플랫폼입니다.
          </FooterDescription>
        </MainSection>

        <FooterDivider />

        <CompanySection>
          <CompanyColumn>
            <CompanyHeader>
              <CompanyTitle>대한민국의학한림원</CompanyTitle>
            </CompanyHeader>
            <CompanyInfo>
              <CompanyDetailRow>
                <CompanyDetailText>대표자 : 한상원</CompanyDetailText>
                <VerticalDivider />
                <CompanyDetailText>사업자등록번호 : 106-82-61301</CompanyDetailText>
              </CompanyDetailRow>
              <CompanyDetailRow>
                <CompanyDetailText>주소 : 서울특별시 중구 삼일대로 363, 장교빌딩 806호</CompanyDetailText>
                <VerticalDivider />
                <CompanyDetailText>이메일 : namok@kams.or.kr</CompanyDetailText>
              </CompanyDetailRow>
            </CompanyInfo>
          </CompanyColumn>

          <CompanyColumn>
            <CompanyHeader>
              <CompanyTitle>투비닥터</CompanyTitle>
              <SocialIcons>
                <SocialIcon href="https://tobedoctor.net" target="_blank" rel="noopener noreferrer">
                  <img src="/images/5.svg" alt="투비닥터" width="24" height="24" />
                </SocialIcon>
                <SocialIcon href="https://instagram.com/tobedoc2020" target="_blank" rel="noopener noreferrer">
                  <img src="/images/4.svg" alt="Instagram" width="24" height="24" />
                </SocialIcon>
                <SocialIcon href="https://youtube.com/@to.be.doctor" target="_blank" rel="noopener noreferrer">
                  <img src="/images/3.svg" alt="YouTube" width="24" height="24" />
                </SocialIcon>
                <SocialIcon href="https://pf.kakao.com/_xiuxgHb" target="_blank" rel="noopener noreferrer">
                  <img src="/images/2.svg" alt="Kakao" width="24" height="24" />
                </SocialIcon>
                <SocialIcon href="https://tobedoctor.stibee.com" target="_blank" rel="noopener noreferrer">
                  <img src="/images/1.svg" alt="News" width="24" height="24" />
                </SocialIcon>
              </SocialIcons>
            </CompanyHeader>
            <CompanyInfo>
              <CompanyDetailRow>
                <CompanyDetailText>대표 : 김경훈</CompanyDetailText>
                <VerticalDivider />
                <CompanyDetailText>사업자등록번호 : 117-82-81966</CompanyDetailText>
              </CompanyDetailRow>
              <CompanyDetailRow>
                <CompanyDetailText>주소 : 서울특별시 강동구 천호대로161길 7, 2동 706호</CompanyDetailText>
                <VerticalDivider />
                <CompanyDetailText>이메일 : tobedoc2020@gmail.com</CompanyDetailText>
              </CompanyDetailRow>
            </CompanyInfo>
          </CompanyColumn>
        </CompanySection>

        <CopyrightSection>
          <CopyrightRow>
            <CopyrightMainText>© 2025 대한민국의학한림원, 투비닥터. All Rights Reserved.</CopyrightMainText>
            <CopyrightSubText>Design System © 2025 Wanted Lab, Inc. CC BY 4.0.</CopyrightSubText>
          </CopyrightRow>
        </CopyrightSection>
      </FooterContent>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: white;
  width: 100%;
  position: relative;
  z-index: 100;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  border-top: 1px solid rgba(112, 115, 124, 0.08);
`;

const FooterContent = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.layout.containerWidth};
  padding: 32px ${({ theme }) => theme.layout.containerPadding};
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
  display: flex;
  
  @media (max-width: 1024px) {
    padding-left: ${({ theme }) => theme.layout.containerPaddingTablet};
    padding-right: ${({ theme }) => theme.layout.containerPaddingTablet};
  }
  
  @media (max-width: 768px) {
    padding-left: ${({ theme }) => theme.layout.containerPaddingMobile};
    padding-right: ${({ theme }) => theme.layout.containerPaddingMobile};
    gap: 24px;
  }
`;

const MainSection = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
  display: flex;
`;

const TopSection = styled.div`
  align-self: stretch;
  justify-content: space-between;
  align-items: center;
  display: inline-flex;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

const LogoSection = styled.div`
  align-self: stretch;
  justify-content: space-between;
  align-items: center;
  display: inline-flex;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

const Logo = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
  height: 32px;
  
  img {
    height: 27px;
    width: 134px;
    display: block;
  }
  
  min-height: 27px;
  min-width: 134px;
`;

const FooterLinks = styled.div`
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
  display: flex;
  
  @media (max-width: 768px) {
    gap: 16px;
    flex-wrap: wrap;
  }
`;

const FooterLinkText = styled.span`
  color: rgba(55, 56, 60, 0.61);
  font-size: 13px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.25px;
  word-wrap: break-word;
  cursor: pointer;
  transition: color 0.2s ease;
  
  &:hover {
    color: #448181;
  }
`;

const FooterDescription = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
  color: rgba(55, 56, 60, 0.61);
  font-size: 13px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.25px;
  word-wrap: break-word;
`;

const FooterDivider = styled.div`
  align-self: stretch;
  height: 1px;
  background: rgba(112, 115, 124, 0.08);
`;

const CompanySection = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
  display: inline-flex;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
  }
`;

const CompanyColumn = styled.div`
  flex: 1 1 0;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  display: inline-flex;
`;

const CompanyHeader = styled.div`
  align-self: stretch;
  justify-content: space-between;
  align-items: center;
  display: inline-flex;
  
  @media (max-width: 768px) {
    justify-content: space-between;
  }
`;

const CompanyTitle = styled.div`
  color: rgba(55, 56, 60, 0.61);
  font-size: 18px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 600;
  line-height: 26.01px;
  word-wrap: break-word;
`;

const SocialIcons = styled.div`
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: flex;
`;

const SocialIcon = styled.a`
  height: 24px;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  cursor: pointer;
  
  img {
    width: 24px;
    height: 24px;
  }
  
  /* 호버 효과 */
  &:after {
    content: '';
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 1000px;
    background-color: #171719;
    opacity: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    transition: opacity 0.2s ease;
  }
  
  &:hover:after {
    opacity: 0.04;
  }
`;

const CompanyInfo = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

const CompanyDetailRow = styled.div`
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: inline-flex;
  flex-wrap: wrap;
  align-content: flex-start;
`;

const CompanyDetailText = styled.div`
  color: rgba(55, 56, 60, 0.61);
  font-size: 13px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.25px;
  word-wrap: break-word;
`;

const VerticalDivider = styled.div`
  width: 1px;
  height: 18px;
  position: relative;
  
  &:after {
    content: '';
    width: 1px;
    height: 10.80px;
    left: 0px;
    top: 3.60px;
    position: absolute;
    background: rgba(112, 115, 124, 0.22);
  }
`;

const CopyrightSection = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  display: flex;
`;

const CopyrightRow = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

const CopyrightMainText = styled.div`
  color: rgba(55, 56, 60, 0.61);
  font-size: 13px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.25px;
  word-wrap: break-word;
`;

const CopyrightSubText = styled.div`
  color: rgba(55, 56, 60, 0.28);
  font-size: 13px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.25px;
  word-wrap: break-word;
`;

export default Footer;